import { render, staticRenderFns } from "./composicion-familiar.vue?vue&type=template&id=1c0e76aa&"
import script from "./composicion-familiar.vue?vue&type=script&lang=ts&"
export * from "./composicion-familiar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports